import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const StandardsContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${colors.greenDark};
  color: ${colors.white};

  .btn-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 60px;

    .btn-get-started {
      width: 33%;

      :hover {
        color: ${colors.blueDark};
        background-color: ${colors.white};
        cursor: pointer;
      }
    }
  }

  .container {
    padding-top: 85px;
    .standards-header-title {
      text-align: center;
      color: ${colors.white};
      margin-bottom: 100px;
    }
    .standards-header-description {
      text-align: center;
      margin-bottom: 134px;
      color: ${colors.white};
    }
    .standard-item {
      margin-bottom: 108px;
      padding: 0 10px;
      .standard-item-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        h3 {
          color: ${colors.white};
        }
        .icon {
          font-size: 40px;
          margin-right: 20px;
        }
      }
      h4 {
        color: ${colors.white};
      }
    }
    .standards-wrapper-sm {
      display: none;
    }
  }
  @media (max-width: ${breakpoints.md}px) {
    .container {
      padding-top: 31px;
      padding-bottom: 70px;
      .standards-wrapper {
        display: none;
      }
      .standards-header-title {
        font-size: 44px;
        text-align: left;
        margin-bottom: 60px;
      }
      .standards-header-description {
        margin-bottom: 45px;
        text-align: left;
      }
      .standards-wrapper-sm {
        display: block;
        padding: 0 30px;
        .carousel-inner {
          padding: 26px 16px 80px;
          .carousel-item {
            h3,
            h4 {
              color: white;
            }
            .title {
              align-items: center !important;
              .icon {
                font-size: 30px;
                color: white;
                margin-right: 12px;
                margin-bottom: 10px;
              }
            }
          }
        }
        .carousel-control-next,
        .carousel-control-prev {
          width: 20px;
        }
        .carousel-indicators {
          li {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            margin-right: 5px;
            margin-left: 5px;
          }
        }
      }
    }
    .btn-get-started {
      margin-top: 80px;
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
